import { ReactNode } from "react"
import { useLocation } from "react-router-dom"

import { TopBar } from "./TopBar"
import { BottomNav } from "./BottomNav"

import { APP_CONTENT_SHELL_CLASSNAME } from "@/shared/constants/layout"

import { cn } from "../lib"

export const Layout = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation()

  return (
    <div
      className={cn(
        "flex h-[100dvh] flex-col pt-[var(--app-top-reserve)]",
        pathname === "/"
          ? "bg-pvp-background bg-cover bg-top"
          : "bg-primary-main"
      )}
    >
      <TopBar />

      <main className="-webkit-overflow-scrolling-touch flex-1 overflow-y-auto overflow-x-hidden overscroll-contain pb-[calc(4rem+var(--app-safe-bottom))] sm:pb-[calc(5rem+var(--app-safe-bottom))]">
        <div className={APP_CONTENT_SHELL_CLASSNAME}>{children}</div>
      </main>

      <BottomNav />
    </div>
  )
}
